import * as yup from 'yup';

const validateEmailList = (value) => {
  if (!value) return true;

  const emails = value.split(';').map((email) => email.trim());

  return emails.every((email) => yup.string().email().isValidSync(email));
};

export const validationSchema = yup.object().shape({
  client: yup.string().required('Informe o cliente'),
  recipients: yup
    .string()
    .required('Informe ao menos um destinatário')
    .test('valid-emails', 'Um ou mais emails de destinatário são inválidos', validateEmailList),
  copy_recipients: yup
    .string()
    .test('valid-emails', 'Um ou mais emails de cópia são inválidos', validateEmailList),
  title: yup.string().required('Informe o título'),
  message: yup.string().required('Informe a mensagem'),
  weekday: yup.string().required('Selecione um dia da semana'),
  attachment_type: yup.string().required(),
  signageReportClients: yup.array().when('attachment_type', {
    is: 'signage_report',
    then: yup.array().min(1, 'Selecione ao menos um cliente'),
  }),
});
